// extracted by mini-css-extract-plugin
module.exports = {"text":"Game_text__1iH5F"};